var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('ModalComponent',{attrs:{"name":"crear-codigos","title":"Crear códigos de invitación para la categoría"},on:{"close":() => _vm.close(false)}},[_c('FormCrearCodigos',{attrs:{"cantidad_codigos":_vm.cantidad_codigos,"usos":_vm.usos},on:{"terminado":_vm.crear}})],1):_c('LoaderComponent')
}
var staticRenderFns = []

export { render, staticRenderFns }